<template>
    <div>
        <v-container>
            <v-card>
                <v-card-title>
                    Lataa tietokantadumppi koneellesi
                </v-card-title>
                <v-card-text>
                    Tietokantadumppi auttaa datan palauttamista häiriötilanteessa. Dumpin lataaminen saattaa kestää hetken.
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="load" :loading="loading">
                        Lataa tietokantadumppi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import store from "@/store"

export default {
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        load() {
            this.loading = true
            fetch('https://apiv4.kiuruvesi.net/getDatabaseDump',
            {
                headers: {
                    "Authorization" : 'Bearer ' + store.getters.token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = new Date().toISOString() + '-kanakoripoolbackup' + '.json';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                alert('Tiedostosi on matkalla, naksauta "OK"!'); // or you know, something with better UX...
            })
            .catch(function (e) {
                alert(e)
            })
            .finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>